<script lang="ts">
    import * as Card from '@/components/ui/card';
    import VehicleAssignmentTable from '@/components/vehicles/VehicleAssignmentTable.svelte';

    type SelectOption = {
        value: string;
        label: string;
    };

    type Props = {
        column: string;
        recordId: string;
        id?: string;
        jobTypeOptions?: SelectOption[];
    };

    let { column, recordId, id = '', jobTypeOptions = [] }: Props = $props();
</script>

<VehicleAssignmentTable
    title="Job Assignments"
    view="relatedList"
    relatedData={{
        column: column,
        record_id: recordId
    }}
    {id}
    {jobTypeOptions}
/>
